import { Box } from "@chakra-ui/react";

export function LocationCard(installer) {
  const { address_line1, postcode } = installer;

  // Encode the complete address to ensure all special characters are correctly interpreted
  const formattedAddress =
    encodeURIComponent(address_line1) + "," + encodeURIComponent(postcode);

  const apiKey = process.env.NEXT_PUBLIC_MAPS_KEY;

  return address_line1 && postcode ? (
    <Box bg={"white"} borderWidth="1px" borderRadius={4} mb={8}>
      <iframe
        width="100%"
        height="450"
        loading="lazy"
        src={`https://www.google.com/maps/embed/v1/place?q=${formattedAddress}&key=${apiKey}`}
      ></iframe>
    </Box>
  ) : null;
}
